import { render } from "./smallSwiper.vue?vue&type=template&id=2e8b0d6b&scoped=true"
import script from "./smallSwiper.vue?vue&type=script&lang=js"
export * from "./smallSwiper.vue?vue&type=script&lang=js"

import "./smallSwiper.vue?vue&type=style&index=0&id=2e8b0d6b&scoped=true&lang=css"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8b0d6b"]])

export default __exports__